import React, { useState } from 'react';
import './CustomInput.css';

export const CustomInput = ({
    label,
    error,
    leftIcon,
    rightIcon,
    onRightIconClick,
    isPassword = false,
    disabled = false,
    containerStyle = {},
    className = '',
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const getBorderColor = () => {
        if (error) return '#FF5252';
        if (isFocused) return '#D4AF37';
        return 'rgba(26, 26, 46, 0.05)';
    };

    return (
        <div className={`custom-input-container ${className}`} style={containerStyle}>
            {label && <label className="input-label">{label}</label>}

            <div
                className={`input-wrapper ${isFocused ? 'focused' : ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
                style={{ borderColor: getBorderColor() }}
            >
                {leftIcon && (
                    <span
                        className="material-icons input-icon left"
                        style={{ color: isFocused ? '#D4AF37' : '#4A4A6A' }}
                    >
                        {leftIcon}
                    </span>
                )}

                <input
                    {...props}
                    type={isPassword && !showPassword ? 'password' : props.type || 'text'}
                    className="custom-input"
                    disabled={disabled}
                    readOnly={disabled}
                    onFocus={(e) => {
                        if (!disabled) {
                            setIsFocused(true);
                            props.onFocus?.(e);
                        }
                    }}
                    onBlur={(e) => {
                        setIsFocused(false);
                        props.onBlur?.(e);
                    }}
                />

                {isPassword && (
                    <button
                        type="button"
                        className="icon-button"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        <span className="material-icons input-icon right">
                            {showPassword ? 'visibility_off' : 'visibility'}
                        </span>
                    </button>
                )}

                {rightIcon && !isPassword && (
                    <button
                        type="button"
                        className="icon-button"
                        onClick={onRightIconClick}
                        disabled={!onRightIconClick}
                    >
                        <span className="material-icons input-icon right">{rightIcon}</span>
                    </button>
                )}
            </div>

            {error && <span className="input-error">{error}</span>}
        </div>
    );
};

export default CustomInput;
